import { enqueueVisitaOfflineOperation } from './visitaOfflineOperationQueue.js';
import { formRevision } from './visitaFormUpdatePolicy.js';
import { validateStartVisitaRequirements } from './visitas/visitasUiService.js';
import { requestVisitaSync } from './visitaLocalFirst.js';
import { activoConfigsForGroup } from './formActivoCompatibility.js';
import { startedVisitaPresentation } from './visitaStartPresentation.js';

export function projectPendingVisitaStart(context, operations, user) {
    const visit = context?.visita;
    if (!visit || visit.estado !== 'pendiente' || !user?.permissions?.includes('visitas.iniciar')) return context;
    const start = operations.find(op => op.type === 'iniciar_visita' && !['applied','superseded'].includes(op.status)
        && op.userId === Number(user.id) && op.visitaId === Number(visit.id)
        && op.payload?.start_contract === 1 && op.payload.owner_empresa_id === Number(user.empresa_id)
        && op.payload.sucursal_id === Number(visit.sucursal_id) && op.payload.form_revision === formRevision(context));
    return start ? startedVisitaPresentation({...context, visita:{...visit, estado:'iniciada', inicio_pendiente_confirmacion:true}}) : context;
}

export async function prepareVisitaStart({user, visit, observacion, client, catalog}) {
    if (!user?.permissions?.includes('visitas.iniciar')) throw Error('No tenés permiso para iniciar visitas.');
    const result = await client.load(visit.id), context = result.context;
    const metadata = (await client.prepared()).find(row => row.visitaId === Number(visit.id));
    if (result.storageError || result.reason === 'form_update_pending' || !metadata?.revision || metadata.candidate || metadata.hint)
        throw Error('Prepará y revisá el formulario con conexión antes de iniciar.');
    if (context?.visita?.estado !== 'pendiente' || Number(context.visita.id) !== Number(visit.id)
        || Number(context.visita.sucursal_id) !== Number(visit.sucursal_id)) throw Error('La visita preparada cambió. Revisala antes de iniciar.');
    const errors = validateStartVisitaRequirements(visit, {canStartPast:user.permissions.includes('visitas.iniciar_atrasada'), observacion});
    if (errors.length) throw Error(errors.join(' '));
    const needsCatalog=(context.template?.fields||[]).some(field=>activoConfigsForGroup(context.template,field).length>0);
    if(needsCatalog){
        const proof = await catalog.inspectSucursal(context.visita.sucursal_id);
        if (!proof.complete) throw Error('Prepará el catálogo de activos con conexión antes de iniciar.');
    }
    if(!Number.isSafeInteger(Number(context.visita.responses_version))||Number(context.visita.responses_version)<0)
        throw Error('La versión preparada de la visita requiere revisión.');
    const payload = {start_contract:1, estado:'iniciada', owner_empresa_id:Number(user.empresa_id),
        sucursal_id:Number(visit.sucursal_id), expected_version:Number(context.visita.responses_version || 0),
        form_revision:formRevision(context), client_started_at:new Date().toISOString(), observacion_estado:observacion || null};
    const operation = await enqueueVisitaOfflineOperation({userId:user.id, visitaId:visit.id, type:'iniciar_visita', payload,
        baseVersion:payload.expected_version});
    requestVisitaSync({visitaId:visit.id});
    return {queued:true, operation};
}
